export const CREATEEDITORDER_GETALLSITEITEMS_LOADING =
  'CREATEEDITORDER_GETALLSITEITEMS_LOADING';
export const CREATEEDITORDER_GETALLSITEITEMS_SUCCESS =
  'CREATEEDITORDER_GETALLSITEITEMS_SUCCESS';
export const CREATEEDITORDER_GETALLSITEITEMS_ERROR =
  'CREATEEDITORDER_GETALLSITEITEMS_ERROR';

export const CREATEEDITORDER_GETPARITEMS_LOADING =
  'CREATEEDITORDER_GETPARITEMS_LOADING';
export const CREATEEDITORDER_GETPARITEMS_SUCCESS =
  'CREATEEDITORDER_GETPARITEMS_SUCCESS';
export const CREATEEDITORDER_GETPARITEMS_ERROR =
  'CREATEEDITORDER_GETPARITEMS_ERROR';

export const CREATEEDITORDER_POSTSAVEORDER_LOADING =
  'CREATEEDITORDER_POSTSAVEORDER_LOADING';
export const CREATEEDITORDER_POSTSAVEORDER_SUCCESS =
  'CREATEEDITORDER_POSTSAVEORDER_SUCCESS';
export const CREATEEDITORDER_POSTSAVEORDER_ERROR =
  'CREATEEDITORDER_POSTSAVEORDER_ERROR';

export const CREATEEDITORDER_GETORDERDETAILS_LOADING =
  'CREATEEDITORDER_GETORDERDETAILS_LOADING';
export const CREATEEDITORDER_GETORDERDETAILS_SUCCESS =
  'CREATEEDITORDER_GETORDERDETAILS_SUCCESS';
export const CREATEEDITORDER_GETORDERDETAILS_ERROR =
  'CREATEEDITORDER_GETORDERDETAILS_ERROR';

export const CREATEEDITORDER_GETORDERTYPES_LOADING =
  'CREATEEDITORDER_GETORDERTYPES_LOADING';
export const CREATEEDITORDER_GETORDERTYPES_SUCCESS =
  'CREATEEDITORDER_GETORDERTYPES_SUCCESS';
export const CREATEEDITORDER_GETORDERTYPES_ERROR =
  'CREATEEDITORDER_GETORDERTYPES_ERROR';

export const CREATEEDITORDER_ADDORDERTYPE = 'CREATEEDITORDER_ADDORDERTYPE';

export const CREATEEDITORDER_CLEARALL = 'CREATEEDITORDER_CLEARALL';



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/createEditOrder/types.js